module.exports = __webpack_public_path__ + "static/media/BG56d883c08453e95007be9822a39adb25.webp";